import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Sparkles, Leaf } from 'lucide-react';

const BrandSupportMessage = ({ isMobile = false }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-gradient-to-br from-champagne/5 via-pearl to-sage/5 rounded-3xl p-6 md:p-12"
        >
            <div className={`max-w-3xl ${isMobile ? 'mx-auto text-center' : ''}`}>
                {/* Decorative Icons */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className={`flex gap-4 mb-8 ${isMobile ? 'justify-center' : ''}`}
                >
                    <motion.div
                        animate={{ rotate: [0, 10, 0] }}
                        transition={{ duration: 3, repeat: Infinity }}
                        className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white flex items-center justify-center"
                    >
                        <Leaf className="w-5 h-5 md:w-6 md:h-6 text-sage" />
                    </motion.div>
                    <motion.div
                        animate={{ scale: [1, 1.1, 1] }}
                        transition={{ duration: 2, repeat: Infinity }}
                        className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white flex items-center justify-center"
                    >
                        <Sparkles className="w-5 h-5 md:w-6 md:h-6 text-champagne" />
                    </motion.div>
                    <motion.div
                        animate={{ rotate: [0, -10, 0] }}
                        transition={{ duration: 3, repeat: Infinity }}
                        className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white flex items-center justify-center"
                    >
                        <Heart className="w-5 h-5 md:w-6 md:h-6 text-champagne" />
                    </motion.div>
                </motion.div>

                {/* Brand Message */}
                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    className={`font-heading font-light text-charcoal mb-6 ${
                        isMobile ? 'text-2xl md:text-3xl' : 'text-3xl md:text-4xl'
                    }`}
                >
                    KROMAIC is more than skincare.<br />
                    We are your beauty support ritual.
                </motion.h2>

                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 }}
                    className={`text-charcoal/60 leading-relaxed mb-8 ${
                        isMobile ? 'text-base' : 'text-lg md:text-xl'
                    }`}
                >
                    Every interaction is an opportunity to deepen your connection with self-care.
                    Our support team consists of certified beauty advisors who understand not just
                    our products, but the emotional journey of skincare. We're here to guide you,
                    celebrate your rituals, and ensure every moment with KROMAIC feels intentional.
                </motion.p>

                {/* Values */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-3'} gap-4`}
                >
                    {[
                        {
                            title: "Certified Advisors",
                            description: "Skincare experts with dermatological training"
                        },
                        {
                            title: "Holistic Approach",
                            description: "Supporting both skin health and emotional wellbeing"
                        },
                        {
                            title: "Global Community",
                            description: "Connecting beauty rituals across continents"
                        }
                    ].map((value, index) => (
                        <div key={index} className="text-center p-4">
                            <h3 className="font-medium text-charcoal mb-2">{value.title}</h3>
                            <p className="text-sm text-charcoal/50">{value.description}</p>
                        </div>
                    ))}
                </motion.div>
            </div>
        </motion.div>
    );
};

export default BrandSupportMessage;